import React from 'react';
import TravelServicePage from './TravelServicePage';

const flightsConfig = {
  name: 'Flights',
  tagline: 'Sync your skies with your stay',
  description:
    'Compare dynamic fares, greener routes, and seamless layovers perfectly aligned with your InnBotics itinerary.',
  heroImage: 'https://images.unsplash.com/photo-1529070538774-1843cb3265df?w=1600',
  accent: '#38bdf8',
  metrics: [
    { value: '52', label: 'connected airlines' },
    { value: '12%', label: 'average savings' },
    { value: '24/7', label: 'fare intelligence' }
  ],
  highlights: [
    {
      icon: '✈️',
      title: 'Fare whisperer',
      description: 'AI watches live fares and nudges you the moment prices dip below your comfort zone.'
    },
    {
      icon: '♻️',
      title: 'Greener miles',
      description: 'Balance carbon scores with timing and price, with offset options baked right into checkout.'
    },
    {
      icon: '🧳',
      title: 'Stay-sync layovers',
      description: 'Hotel check-in and flight schedules talk to each other so you land exactly when your room is ready.'
    }
  ],
  journey: [
    {
      title: 'Personalise your sky profile',
      description: 'Tell us your cabin style, loyalty numbers, and deal-breakers—we build a flight fingerprint for you.'
    },
    {
      title: 'Track the fare pulse',
      description: 'Machine learning keeps watch on dozens of routes and alerts you before the best window closes.'
    },
    {
      title: 'Lock the perfect pairing',
      description: 'Book flights and stays in one flow, with transfers and add-ons automatically adjusted.'
    },
    {
      title: 'Fly with confidence',
      description: 'Get real-time updates, digital boarding, and reroute suggestions if anything shifts.'
    }
  ],
  testimonials: [
    {
      quote:
        'We shaved two hours off every connection this quarter. The system predicts airport congestion before our crew does.',
      name: 'Nate Howard',
      role: 'Operations Lead, AirLux Breaks'
    },
    {
      quote:
        'Loved the carbon insights. We picked a greener route without spending more—our team noticed the difference.',
      name: 'Priya Deshmukh',
      role: 'Founder, Vivid Retreats'
    }
  ],
  cta: {
    title: 'Pilot smarter journeys starting today',
    description: 'Bundle your flights with InnBotics stays, transfers, and experiences—all orchestrated in one canvas.',
    actions: [
      { label: 'Plan a flight', href: '/booking', primary: true },
      { label: 'Talk to concierge AI', href: '/chat', primary: false }
    ]
  }
};

const FlightsPage = () => <TravelServicePage config={flightsConfig} />;

export default FlightsPage;
